module.exports = require('./hls')



// WEBPACK FOOTER //
// ./src/playbacks/hls/index.js